import React from 'react';
import PropTypes from 'prop-types';
import { Card, Col, Row } from 'react-bootstrap';
import FalconCardHeader from 'components/common/FalconCardHeader';
// import CardDropdown from 'components/common/CardDropdown';
import weatherIcon from 'assets/img/icons/weather-sm.jpg';
import Flex from 'components/common/Flex';

const Weather = ({ locationWeather, ...rest }) => (
  <Card {...rest} className="h-100">
    <FalconCardHeader
      title="Weather"
      light={false}
      titleTag="h6"
      className="pb-0"
      // endEl={<CardDropdown />}
    />
    <Card.Body className="pt-2">
      <Row className="g-0 h-100 align-items-center">
        <Col as={Flex} alignItems="center">
          <img className="me-3" src={weatherIcon} alt="" height="60" />
          <div>
            <h6 className="mb-2">{locationWeather?.name}</h6>
            <div className="fs-11 fw-semibold">
              <div className="text-warning">
                {locationWeather?.weather[0]?.main}
              </div>
            </div>
          </div>
        </Col>
        <Col xs="auto" className="text-center ps-2">
          <div className="fs-5 fw-normal font-sans-serif text-primary mb-1 lh-1">
            {(((locationWeather?.main?.temp - 273.15) * 9) / 5 + 32).toFixed(0)}
            °
          </div>
          <div className="fs-10 text-800">
            {(
              ((locationWeather?.main?.temp_max - 273.15) * 9) / 5 +
              32
            ).toFixed(0)}
            ° /{' '}
            {(
              ((locationWeather?.main?.temp_min - 273.15) * 9) / 5 +
              32
            ).toFixed(0)}
            °
          </div>
        </Col>
      </Row>
    </Card.Body>
  </Card>
);

Weather.propTypes = {
  className: PropTypes.string,
  locationWeather: PropTypes.any
};

export default Weather;
